export default "__VITE_PUBLIC_ASSET__d53531f5__"